'use client';

import { useAuth } from '@clerk/clerk-react';
import { useMutation } from '@tanstack/react-query';

import { apiClient } from '../api/client';

export function useCreateSetupIntent() {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async () => {
      const token = await getToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const { data, error, response } = await apiClient.POST(
        '/api/v1/billing/setup-intents',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (error || !response.ok || !data) {
        throw new Error('Failed to create setup intent');
      }

      return {
        clientSecret: data.clientSecret,
        setupIntentId: data.setupIntentId,
      };
    },
  });
}
